export const    fieldData = [{
    type:'roomSelect',
    label:"房间选择",
    name:"selectRoom",
    required:true,
    items:[{
        text:"客厅",
        value:"keting",
        icon:"keting",
    },{
        text:"餐厅",
        value:"canting",
        icon:"canting",
    },{
        text:"书房",
        value:"shufang",
        icon:"shufang",
    },{
        text:"儿童房",
        value:"ertongfang",
        icon:"ertongfang",
    },{
        text:"主卧",
        value:"zhuwo",
        icon:"zhuwo",
    },{
        text:"客卧",
        value:"kewo",
        icon:"kewo",
    },{
        text:"阳台",
        value:"yangtai",
        icon:"yangtai",
    },{
        text:"自定义",
        value:"zidingyi",
        icon:"zidingyi",
    }]
},{
    type:'imgSelect',
    label:"颜色分类",
    name:"colorType",
    required:true,
    items:[]
}
/*,{
    type:'select',
    label:"面料方向",
    required:true,
    name:"mianliaoDir",
    items:[{
        text:"买宽",
        value:"FixHeight"
    },{
        text:"买高",
        value:"FixWidth",
    }]

}*/
,{
    type:'select',
    label:"转角",
    name:"radian",
    items:[]
},{
    type:'select',
    label:"粘贴方向",
    required:true,
    name:"pasteDirection",
    items:[]
},{
    type:'select',
    label:"加工方式",
    required:true,
    name:"jiagongfangshi",
    items:[]
},{
    type:'select',
    label:"褶倍",
    required:true,
    name:"pleatTimes",
    items:[]
},{
    type:'select',
    label:"分片方式",
    required:true,
    name:"fenpianfangshi",
    items:[]
},{
    type:'imgSelect',
    label:"复杂加工",
    name:"fuzhaJiagong",
    ismulti:true,
    // required:true,
    items:[]
},{
    type:'imgSelect',
    label:"绑带",
    name:"bangdai",
    items:[]
}]

export const  TypeMaps ={
    "颜色分类":{
      arrayName:"productList",
      idName:"id",
      textName:"number"
    },"加工方式":{
      arrayName:"installationCraftList",
      idName:"optionValue",
      textName:"optionDesc"
    },"褶倍":{
      arrayName:"pleatTimes",
      idName:"id",
      textName:"name"
    },"粘贴方向":{
      arrayName:"pasteDirectionList",
      idName:"optionValue",
      textName:"optionDesc"
    },"分片方式":{
      arrayName:"installationCraftList",
      idName:"optionValue",
      textName:"optionDesc", 
        memo:"memo"
    },"复杂加工":{
      arrayName:"expandItems",
      idName:"id",
      textName:"name"
    },"绑带":{
      arrayName:"bangDaiProducts",
      idName:"id",
      textName:"number"
    }
}